const $$splitComponentImporter = () => import('/src/src/routes/(compatibility)/sign_up.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

/**
 * Redirect old onboarding route to new enrollment route
 *
 * @deprecated
 */
export const Route = createFileRoute("/(compatibility)/sign_up")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});